module.exports = __webpack_public_path__ + "img/highroller_1920.700bd19f.png";